import registry from 'rlink-repos/registry';
import {Article, Author} from 'rlink-blog';

import StudioSlideshowImage from 'content-types/StudioSlideshowImage';
import CityGalleryImage from 'content-types/CityGalleryImage';
import Franchise from 'content-types/Franchise';
import Profile from 'content-types/Profile';
import History from 'content-types/History';
import HomePage from './content-types/HomePage';

import {
  ArticlesIndexer,
  ArticleBySlug,
  FranchiseIndexer,
  StudioSlideshowImageIndexer,
  ProfileIndexer,
  HistoryIndexer,
  CityGalleryImageIndexer,
} from './indexers';

class RelicArticle extends Article {
  get adminLabel () {
    return ('title' in this) && this.title.length > 0 ? this.title : '<blank article>';
  }

  get bannerImageFormats () {
    return {
      src: this.bannerPath,
      formats: [
        {contentType: 'image/webp', fileExt: 'webp'},
        {contentType: 'image/jpeg', fileExt: 'jpg'},
      ],
      widths: [
        1920, 1440, 1024, 750, 680, 560, 450, 290,
      ],
    };
  }
}

export default registry({
  RelicArticle,
  ArticlesIndexer,
  ArticleBySlug,
  Author,
  Franchise,
  FranchiseIndexer,
  StudioSlideshowImage,
  StudioSlideshowImageIndexer,
  Profile,
  ProfileIndexer,
  History,
  HistoryIndexer,
  CityGalleryImage,
  CityGalleryImageIndexer,
  HomePage,
});



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/content.js